import * as React from 'react';
import { connect } from 'react-redux';
import NotifyHOC from '../../HOC/Notifications';
import { Switch, Route, Redirect } from 'react-router-dom';

import Overview from './overview';
import BotSettings from './botSettings';

import {
    NEW_PROJECT,
    AUDIENCE,
    EDIT_NEW_PROJECT,
    EDIT_QUESTIONS,
    PREVIEW
} from '../../constants/routes';
import Questions from './questions';
import { PageNotFound } from '../common/noMatchPage';
import Audience from './Audience';

interface NewProjectRouterProps {
    isNewProjectCreated: boolean;
    newProject: any;
}
const NewProjectRouter: React.SFC<NewProjectRouterProps> = () => {
    return (
        <Switch>
            <Route exact path={NEW_PROJECT} component={Overview} />
            <Route exact path={EDIT_NEW_PROJECT} component={Overview} />
            <Route exact path={AUDIENCE} component={Audience} />
            <Route exact path={EDIT_QUESTIONS} component={Questions} />
            <Route exact path={PREVIEW} component={BotSettings} />
            <Redirect to="/workspace" />
        </Switch>
    );
};

const mapStateToProps = (store) => {
    const {
        projectReducer: { isNewProjectCreated, newProject }
    } = store;
    return {
        isNewProjectCreated,
        newProject
    };
};

export default NotifyHOC(connect(mapStateToProps, null)(NewProjectRouter));
